var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlayerPlayOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24h24V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M11.997 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 2c-4.41 0-8 3.589-8 8s3.59 8 8 8c4.411 0 8-3.589 8-8s-3.589-8-8-8zM9.704 8.43a1.001 1.001 0 011.008.013l4.5 2.7a1 1 0 010 1.715l-4.5 2.7a1 1 0 01-1.515-.857V9.3c0-.36.194-.692.507-.87z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg%3E %3Cpath d='M0 24L24 24 24 0 0 0z'/%3E %3Cpath fill='%23231815' d='M11.997 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 2c-4.41 0-8 3.589-8 8s3.59 8 8 8c4.411 0 8-3.589 8-8s-3.589-8-8-8zM9.704 8.43c.315-.178.698-.172 1.008.013l4.5 2.7c.3.18.485.506.485.857 0 .352-.184.677-.485.858l-4.5 2.7c-.158.095-.337.143-.515.143-.17 0-.34-.043-.493-.13-.313-.178-.507-.51-.507-.87V9.3c0-.36.194-.692.507-.87z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcPlayerPlayOutline as ReactComponent };